module.exports = (__webpack_require__(70832))(6677);